import api from "@/api/order";
import { normalizeOrderErrors } from "@/utils/order/validationErrors";
import apiSocketService from "@/services/apiSocket";
import apiContour, { API_CONTOUR_ORCHESTRATOR } from "@/services/apiContour";
import googleAutocompleteAudit from "@/services/googleAutocompleteAudit";
// import isEmpty from 'lodash/isEmpty';

import {
  ORDER_PRODUCT_TYPE_PRODUCT,
  ORDER_PRODUCT_TYPE_SET,
  STATUS_APPROVED,
  STATUS_DECLINE,
  STATUS_TRASH,
  STATUS_PAYMENT_LINK,
  FINAL_STATUSES,
  STORAGE_ORDER_SCRIPS,
  STORAGE_ORDER_FORM,
  ORDER_TYPE_INCOME,
  ORDER_TYPE_NEW,
  ORDER_TYPE_CREATED,
  OPEN_AT_ORDER,
  OPEN_AT_ORDER_LOCAL,
  MAIN_PRODUCT_KEY,
  STATUS_NEW,
  STATUS_RECALL,
  STATUS_CALL_OUT,
  FORM_REQUEST_TYPE_MANUAL,
  SPECIAL_PRODUCT_IDS,
  ORDER_TYPE_LAST_CHANCE,
  STATUS_APPROVED_PARTIAL_PAYMENT_LINK,
  ORDER_TYPE_DELIVERY_LOGISTIC
} from "@/constants/order";

import {LOG_TYPES, SIP_STATUSES} from "@/constants/phone"
import { applySpecialVat } from "@/utils/applySpecialVat.js";

import { isArray } from "util";
import { EventBus } from "@/eventBus";
import { get } from "http";
import {EMPLOYEE_STATE_INACTIVE} from "@/constants/employee";
import {FORM_REQUEST_TYPE_PANEL, ORDER_TYPE_POST_SALE} from "../../constants/order";
import {CHECK_PAYMENT_LINKS_LIFETIME} from "@/constants/api";

const DISABLED_ORDER_TYPE = 14;
const MODE_AUTO_PHONE_NUMBER = "100";
const FETCH_ORDER_RETRY_DELAY_MS = 20000;
const FETCH_ORDER_RETRY_MESSAGE = "Poor connection detected. Retrying order loading...";
let refetchInterval = null;
let activeFetchOrderPromise = null;
let activeFetchOrderId = null;
let activeSaveOrderPromise = null;
let activeIncomingCallPromise = null;
let fetchOrderRetryTimeout = null;
const ORDER_CONVERSATION_DURATION_STORAGE_KEY = "order-conversation-duration";

function googleAuditContour() {
  try { return apiContour.getCurrentContour(); } catch (_) { return null; }
}

function getOrderConversationDurationStorage() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return null;
  }

  return window.sessionStorage;
}

function readStoredOrderConversationDuration() {
  const storage = getOrderConversationDurationStorage();
  if (!storage) {
    return null;
  }

  const rawValue = storage.getItem(ORDER_CONVERSATION_DURATION_STORAGE_KEY);
  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (e) {
    storage.removeItem(ORDER_CONVERSATION_DURATION_STORAGE_KEY);
    return null;
  }
}

function writeStoredOrderConversationDuration(orderId, durationSeconds) {
  const storage = getOrderConversationDurationStorage();
  if (!storage || !orderId) {
    return;
  }

  storage.setItem(
    ORDER_CONVERSATION_DURATION_STORAGE_KEY,
    JSON.stringify({
      orderId: Number(orderId),
      durationSeconds: Math.max(0, Number(durationSeconds) || 0),
    })
  );
}

function clearStoredOrderConversationDuration() {
  const storage = getOrderConversationDurationStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(ORDER_CONVERSATION_DURATION_STORAGE_KEY);
}

function scheduleFetchOrderRetry(dispatch, orderId) {
  if (fetchOrderRetryTimeout) {
    return;
  }

  fetchOrderRetryTimeout = setTimeout(() => {
    fetchOrderRetryTimeout = null;
    dispatch("fetchOrder", orderId);
  }, FETCH_ORDER_RETRY_DELAY_MS);
}

function clearFetchOrderRetry() {
  if (!fetchOrderRetryTimeout) {
    return;
  }

  clearTimeout(fetchOrderRetryTimeout);
  fetchOrderRetryTimeout = null;
}

const tax = {
  is_vat_rounding: false, // по дефолту ндс округляется
  rounding_total_final: 0, // фин стоимость после округления
  diff_total_final: 0, // разница между исх суммой и округленной
  precision: 1, // округление к целому, а можно к 10 или 100 например
};

const initData = {
  allowReFetchOrder: true,
  order: null,
  statusList: null,
  forms: {
    productsAndSets: {
      count: 0,
      products: [
        {
          value: null,
          id: null,
        },
      ],
      quantity: [1],
      costs: [0],
      sumCosts: [0],
      free: [false],
      gifts: [],
      originIds: [],
      prices: [],
      fulfillment: null,
      status: null,
      // isPaymentLink: false,
      discountedCosts: [],
      newSumCosts: [0],
      shipping_price: 0,
      updatedCostForSetProduct: {},
    },
    requestForm: {
      address: {},
      general: {},
      phones: [""],
      shipping_price: 0,
      comment: "",
      start_timestamp: null,
      final_timestamp: null,
      discount: null,
      recallLanguageQueueId: null,
      delivery_type: null,
      customer_address: "",
      opened_at: null,
    },
    transformOrderData: {},
  },
  showOrderForm: false,
  isLoadingOrder: false,
  refetchOrder: false,
  errors: {},
  errorsRules: {},
  orderPage: false,
  script: {
    logs: [],
    finished: false,
  },
  serverErrors: null,
  noVATCheckbox: false,
  vatProducts: [],
  isIFrame: false,
  requestFormType: null,
  notReadyCheckbox: false,
  switchToTrainingCheckbox: false,
  isAllowNoVat: false,
  isResetVATCheckbox: false,
  callLogId: null,
  orderTypes: null,
  orderLoadingMessage: "",
  finalPrice: 0,
  newSumCosts: [0],
  isIframeOrderSaved: false,
  autoApproveLink: null,
  isOrderOpened: false,
  customDiscount: {},
  operatorsList: {},
  operator: null,
  operator_id: null,
  callLogData:[],
  local_timestamp: Math.round(Date.now() / 1000),
  roundCorrectionKoef: 1, //для коррекции цен товаров заказа при округлении конечной стоимости
  roundShippingCorrectionKoef: 1, //для коррекции цены доставки заказа при округлении конечной стоимости
  attemptsByCurrentOperator: [],
  hasData: false,
  hasLastCallAttempts: false,
  hasAttemptsByCurrentOperator: false,
  validateStatusFailWithRecord: false,
  partial_payment_link: false,
  isLogisticCall: false,
  orderConversationDurationSeconds: 0
};

function getProductVat(vatList, countryId, productId) {
  let result = 0;
  if (typeof vatList != "undefined" && countryId in vatList) {
    if (
      applySpecialVat() &&
      productId in vatList[countryId] &&
      vatList[countryId]["special_vat"]
    ) {
      result = vatList[countryId]["special_vat"][productId];
    } else if (productId in vatList[countryId]) {
      result = vatList[countryId][productId];
    } else if (vatList[countryId]) {
      result = vatList[countryId]["main"];
    }
  }

  return result;
}

function isTaxRoundingChangeScript() {
  tax.precision = 1;
  tax.is_vat_rounding = true;

  if(window?.changeScript?.methods?.getPrecision){
    tax.precision = window.changeScript.methods.getPrecision();
  }

  return tax.is_vat_rounding;
}

function round(value, decimals) {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
}

function round_total_final(price, precision = 1) {
  return Math.ceil(price / precision) * precision;
}

export default {
  state: {
    ...initData,
  },
  getters: {
    getSumQuantity(state) {
      const { quantity, free } = state.forms.productsAndSets;
      let sumQuantity = 0;

      quantity.forEach((val, i) => {
        const isFreeProduct = free[i];
        if (!isFreeProduct) {
          sumQuantity += val;
        }
      });

      return sumQuantity;
    },
    getSumQuantityAll(state) {
      const { quantity, gifts } = state.forms.productsAndSets;
      let sumQuantity = 0;

      quantity.forEach((val) => {
        sumQuantity += val;
      });

      gifts.forEach((gift) => {
        if (!gift) return;
        sumQuantity += +gift.add_product_quantity;
      });

      return sumQuantity;
    },
    getOrderCorrections(state) {
      if (!state.order || !state.order.correction_list) return [];
      return Object.entries(state.order.correction_list).map(([k, item]) => ({
        value: k,
        text: item,
      }));
    },
    getReadOnlyDiscount(state, getters) {
      return  false;
    },
    getDisabledDiscount(state) {
      if (!state.order) return true;

      const formDiscount = state.order.form.discount;
      const orderDiscount = state.order.order.discount;

      if (!formDiscount && orderDiscount) return true;

      return false;
    },
    getProductsSumWithoutVAT(state, getters) {
      if (state.order && state.order.order) {
        let result = null;
        let discount = getters.getDiscount;
        const shippingPrice = getters.getShippingPrice;
        const { vatProducts } = state;
        let sumCosts = state.forms.productsAndSets.sumCosts.map((item, k) => {
          const isFree = state.forms.productsAndSets.free[k];
          if (isFree) return 0;
          return item;
        });
        const isSet = getters.checkIsSetInForm;
        if (isTaxRoundingChangeScript()) {
           sumCosts = sumCosts.map((val, i) => {
            const vat = vatProducts[i] ?  vatProducts[i].vat / 100 : 0;
            const valWithTax = val * (1 + vat);
            return round(valWithTax/(1+vat), 4);
          });
          state.newSumCosts = sumCosts;
          state.forms.productsAndSets.newSumCosts = sumCosts;
          discount = getters.getDiscount;
          if (isSet) {
            state.forms.productsAndSets.updatedSetProducts = state.forms.productsAndSets.MODIFIED_SET_PRODUCTS.map((item, k) => {
              item['cost'] = round(item['default_price'], 4);
              result = +result + item['cost'];

              return item;
            })
            state.newSumCosts = [result]
            state.forms.productsAndSets.newSumCosts = [result]
            discount = getters.getDiscount;
            return +result + +discount + +shippingPrice;
          }
        } else {
          state.newSumCosts = sumCosts;
          state.forms.productsAndSets.newSumCosts = sumCosts;
        }

        result = sumCosts.reduce((acc, val) => {
          return acc + +val;
        });

        return +result + +discount + +shippingPrice;
      }
    },
    getMainProductCostWithoutVAT(state) {
      if (state.order && state.forms.productsAndSets) {
        return state.forms.productsAndSets.costs[0];
      }
    },
    getDiscount(state) {
      if (!state.order) return 0;
      const { discount } = state.order.order;
      const discountRequest = state.forms.requestForm.discount;

      if (!discount && !discountRequest) {
        state.forms.productsAndSets = {
          ...state.forms.productsAndSets,
          discountedCosts: [],
        };
        return 0;
      }

      const { free, newSumCosts } = state.forms.productsAndSets;
      const discountedCosts = newSumCosts.map((cost, k) => {
        if (free[k]) return 0;
        return cost * (discountRequest / 100);
      });

      if (!discountedCosts.length) return 0;

      state.forms.productsAndSets = {
        ...state.forms.productsAndSets,
        discountedCosts,
      };

      const discountedCostsSum = discountedCosts.reduce((acc, v) => acc + +v);

      return window.currency(discountedCostsSum / discountedCosts.length);
    },
    showVATBlock(state) {
      if (!state.order) return false;

      if (state.requestFormType === FORM_REQUEST_TYPE_MANUAL) return true;

      const { isAllowNoVat } = state.forms.requestForm;
      const { status } = state.order.order;
      if (
        isAllowNoVat &&
        [STATUS_NEW, STATUS_RECALL, STATUS_CALL_OUT].indexOf(status) !== -1
      ) {
        return isAllowNoVat;
      }

      const { no_vat } = state.order.form;

      let result = false;
      const { last_queue_id } = state.order.order;

      const {
        queues,
        vat_display_products,
        is_condition_display,
      } = state.order.form;
      const { order_products } = state.order;

      if(no_vat && !is_condition_display){
        return true;
      }

      if (is_condition_display || no_vat) {
        if (
          last_queue_id &&
          queues &&
          queues.length &&
          queues.includes(last_queue_id + "")
        ) {
          result = true;
        }

        if (vat_display_products && isArray(vat_display_products)) {
          Object.values(order_products).forEach((product) => {
            if (
              vat_display_products &&
              vat_display_products.includes(product.product_id + "")
            )
              result = true;
          });
        }
      } else {
        result = true;
      }

      return result;
    },
    checkDisabledVATCheckbox(state, getters) {
      if (!state.order) return true;

      if (state.requestFormType === FORM_REQUEST_TYPE_MANUAL) return false;

      let result = true;

      const { type_id } = state.order.order;
      const { no_vat } = state.order.form;
      const { isAllowNoVat } = state;
      const orderNoVat = state.order.order.no_vat;

      if (state.forms.requestForm.isAllowNoVat) {
        return false;
      }
      if (no_vat) {
        if (orderNoVat) {
          return true;
        }
        if (
          type_id === ORDER_TYPE_NEW ||
          type_id === ORDER_TYPE_CREATED ||
          type_id === ORDER_TYPE_LAST_CHANCE ||
          type_id === ORDER_TYPE_POST_SALE
        ) {
          result = true;
          if (isAllowNoVat) {
            result = false;
          } else {
            const quantitySum = getters.getSumQuantityAll;
            if (quantitySum >= 3) {
              result = false;
            } else {
              state.isResetVATCheckbox = true;
            }
          }
        }
      }

      return result;
    },
    getProductsVATPercent(state) {
      if (state.order && state.order.products) {
        const resultVAT = [];
        const resultProductsVAT = [];
        const { country_vat, country_id } = state.order.order;
        const { vat_list } = state.order;

        state.forms.productsAndSets.products.forEach((item, key) => {
          if (item.id) {
            if (item.type === ORDER_PRODUCT_TYPE_PRODUCT) {
              const productsCount = state.forms.productsAndSets.products.filter(
                (product) => product.id !== null
              ).length;
              const productVat = getProductVat(vat_list, country_id, item.id);

              const product = {
                id: item.id,
                vat: productVat ? productVat : country_vat,
                quantity: state.forms.productsAndSets.quantity[key],
              };

              resultProductsVAT.push(product);
              resultVAT.push(product.vat / productsCount);
            } else if (item.type === ORDER_PRODUCT_TYPE_SET) {
              let resultProductVAT = 0;
              state.order.sets.map((set) => {
                if (set.id == item.id) {
                  for (let i in set.products) {
                    const productVat = getProductVat(
                      vat_list,
                      country_id,
                      set.products[i].id
                    );
                    if (productVat) {
                      resultProductVAT = productVat;
                    }
                  }

                  resultProductsVAT.push({
                    vat: resultProductVAT,
                  });
                  resultVAT.push(resultProductVAT);
                }
              });
            }
          }
        });

        if (!resultVAT.length) return 0;
        const middleVat = resultVAT.reduce((acc, cur) => acc + cur);
        state.vatProducts = resultProductsVAT;

        return round(middleVat, 4);
      }
    },
    getProductsVAT(state, getters) {
      if (state.order && state.order.products) {
        const totalSum = getters.getFinalPrice;
        const productsSum = getters.getProductsSumWithoutVAT;
        const result = totalSum - productsSum;

        return result ? window.currency(result) : 0;
      }

      return 0;
    },
    getShippingPrice(state) {
      if (!state.order) return 0;
      let shipping = state.forms.requestForm.shipping_price;

      return +shipping;
    },
    getTotalSum(state, getters) {
      if (state.order) {
        if (state.order.order.type_id === ORDER_TYPE_DELIVERY_LOGISTIC) {
          return state.order.order.final_price;
        }
        let shipping = state.forms.requestForm.shipping_price;
        let shipping_vat = state.forms.requestForm.shipping_vat;

        if (shipping && shipping_vat) {
          shipping = shipping + shipping * (shipping_vat / 100);
        }

        const { vatProducts } = state;
        let productsVat = [];

        const totalSum = window.currency(shipping);

        const isSet = getters.checkIsSetInForm;

        let result = state.forms.productsAndSets.newSumCosts;
        if (!isSet) {
          result = result
            .map((item, k) => {
              const isFree = state.forms.productsAndSets.free[k];
              const discount = state.forms.productsAndSets.discountedCosts[k];

              if (isFree) return 0;
              if (typeof vatProducts[k] !== "undefined") {
                let vat = vatProducts[k].vat / 100;

                productsVat.push(vat);
                const finalPrice =
                  typeof discount !== "undefined" ? +item - discount : +item;

                return round(finalPrice + finalPrice * vat, 4);
              }
            })
            .reduce((acc, val) => acc + +val);
        } else if (applySpecialVat) {
          // result = result[0];
          result = state.forms.productsAndSets.sumCosts[0];
        }

        if (typeof result === "undefined" || !result) return totalSum;

        state.forms.productsAndSets.shipping_price = +shipping;
        let total = +result + +shipping;
        if (isTaxRoundingChangeScript()) {
          if (+shipping) {
            let roundShipping = round_total_final(+shipping, tax.precision);
            state.roundShippingCorrectionKoef = roundShipping / +shipping;
            state.forms.productsAndSets.shipping_price = roundShipping;
          }

          let roundResult = round_total_final(+result, tax.precision);
          tax.rounding_total_final = roundResult + state.forms.productsAndSets.shipping_price;
          tax.diff_total_final = tax.rounding_total_final - total;
          state.roundCorrectionKoef = roundResult / +result;
          return window.currency(tax.rounding_total_final);
        } else {
          state.roundCorrectionKoef = 1;
          state.roundShippingCorrectionKoef = 1;
          return window.currency(total);
        }
      }
    },
    getFinalPrice(state) {
      let shipping = state.forms.requestForm.shipping_price;
      let shipping_vat = state.forms.requestForm.shipping_vat;

      if (shipping && shipping_vat) {
        shipping = shipping + shipping * (shipping_vat / 100);
      }

      const { vatProducts } = state;

      let result = state.forms.productsAndSets.newSumCosts
        .map((item, k) => {
          const isFree = state.forms.productsAndSets.free[k];
          let discount = state.forms.productsAndSets.discountedCosts[k];

          if (isFree) return 0;
          if (typeof vatProducts[k] !== "undefined") {
            let vat = vatProducts[k].vat / 100;

            const finalPrice =
              typeof discount !== "undefined" ? +item - discount : +item;

            return round(finalPrice + finalPrice * vat, 4);
          }
        })
        .reduce((acc, val) => acc + +val);
      result += +shipping;

      return +result;
    },

    checkIsSetInForm(state) {
      return state.forms.productsAndSets.products.some(
        (product) => product.type === ORDER_PRODUCT_TYPE_SET
      );
    },

    getSelectedSetInForm(state) {
      return state.forms.productsAndSets.products.filter(
        (product) => product.type === ORDER_PRODUCT_TYPE_SET
      );
    },

    checkIsSelectedSetInOrder(state) {
      if (!state.order) return false;
      return !!state.order.order.set_id;
    },
    showCloseButtonToItem: (state) => () => {
      const {
        forms: { productsAndSets },
      } = state;

      if (productsAndSets.count === 2) {
        const productId = productsAndSets.products[1].id;
        if (productId) {
          return true;
        }
        return false;
      }

      return productsAndSets.count > 1;
    },
    showFreeCheckbox: (state) => (key) => {
      if (!state.order) return false;

      const {
        forms: { productsAndSets },
      } = state;

      const { quantity } = productsAndSets;

      const isNullProduct = productsAndSets.products.some(
        (item) => item.id === null
      );

      const freeProductIndex = productsAndSets.free.findIndex(
        (x) => x === true
      );

      const isSpecialProduct = SPECIAL_PRODUCT_IDS.map((i) => +i).some(
        (i) => i === +productsAndSets.products[key].id
      );

      const totalQuantity = productsAndSets.quantity.reduce((a, b) => a + b);

      if (productsAndSets.count == 2 && isNullProduct) return false;
      if (isSpecialProduct) return false;

      if (productsAndSets.count > 1 && totalQuantity > 1 && state.order.order.webmaster_id === 8707) {
        return true;
      }

        if (productsAndSets.count > 1 &&
            totalQuantity > 1 &&
            productsAndSets.costs.includes(129000) &&
            state.order.order.country_id === 30) {
            return true;
        }
        if (productsAndSets.count > 1 &&
            totalQuantity > 1 &&
            productsAndSets.costs.includes(590) &&
            state.order.order.country_id === 3) {
            return true;
        }

      if (productsAndSets.count > 1 && totalQuantity > 2) {
        if (totalQuantity > 3 && totalQuantity <= 5) {
          if (quantity[key] > 1) {
            return false;
          } else return true;
        } else if (totalQuantity > 5 && totalQuantity <= 7) {
          if (quantity[key] > 2) {
            return false;
          }
          return true;
        } else if (totalQuantity > 7 && totalQuantity <= 9) {
          if (quantity[key] > 3) {
            return false;
          }
          return true;
        } else if (totalQuantity > 9) {
          if (quantity[key] > 4) {
            return false;
          }
          return true;
        }
      }

      return false;
    },
    getMaxProductQuantityForInput(state) {
      if (!state.order) return 10;

      const { count } = state.order.products.rules.price_rules;

      return Object.keys(count).length;
    },
    getTotalProductsQuantity(state) {
      if (!state.order) return 0;

      const { quantity } = state.forms.productsAndSets;

      if (!quantity.length) return 0;

      return quantity.reduce((acc, val) => acc + +val);
    },
    getSelectedProductsIds(state) {
      const { products } = state.forms.productsAndSets;
      return products.map((product) => product.id);
    },
    getDisabledSaveButton(state) {
      if (!state.order) return [];

      const { finished } = state.script;
      const { script } = state.order;
      const { fulfillment, products } = state.forms.productsAndSets;
      const { block_save_by_approve } = state.order.products.rules.price_rules; //.modification;

      const selectedStatus = state.forms.productsAndSets.status;
      if (!selectedStatus) return true;

      let disabled = false;
      if (
        selectedStatus.id == STATUS_APPROVED ||
        selectedStatus.id == STATUS_DECLINE ||
        selectedStatus.id == STATUS_TRASH ||
        selectedStatus.id == STATUS_PAYMENT_LINK
      ) {
        if (
          selectedStatus.id == STATUS_APPROVED ||
          selectedStatus.id == STATUS_PAYMENT_LINK
        ) {
          if (!fulfillment) {
            disabled = true;
            return disabled;
          }

          if (block_save_by_approve.indexOf(+selectedStatus.id) !== -1) {
            products.forEach(({ id }) => {
              if (block_save_by_approve.indexOf(+id) !== -1) {
                disabled = true;
                return;
              }
            });
          }
        }
      }

      if (FINAL_STATUSES.includes(+selectedStatus.id)) {
        if (script && !finished) disabled = true;
        else disabled = false;
      }

      return disabled;
    },
    getRecallMaxDates(state) {
      return (state.statusList && state.statusList.recall_max_dates) || {};
    },
    getRecallLimits(state) {
      return (state.statusList && state.statusList.recall_limits) || {};
    },
    getFilteredStatusList(state, getters) {
      if (!state.statusList || !state.order) return [];
      const { status } = state.statusList;
      const { finished } = state.script;

      const script = getters.getOrderScript;
      const { fulfillment, products } = state.forms.productsAndSets;
      const { block_save_by_approve } = state.order.products.rules.price_rules; //.modification;
      const emptyProductField = getters.hasEmptyProductField;
      const neededStatusList = state.order.form.buttons.split(",").sort();

      return neededStatusList
        .map((id) => {
          if (status[id]) {
            let disabled = false;
            let disabledInfo = null;

            if (
              id == STATUS_APPROVED ||
              id == STATUS_DECLINE ||
              id == STATUS_TRASH ||
              id == STATUS_PAYMENT_LINK
            ) {
              if (script && !finished) {
                disabled = true;
              }
            }

            if (id == STATUS_APPROVED || id == STATUS_PAYMENT_LINK) {
              products.forEach(({ id, type }) => {
                if (type !== ORDER_PRODUCT_TYPE_SET) {
                  if (block_save_by_approve.indexOf(+id) !== -1) {
                    disabled = true;
                    return;
                  }
                }
              });

              if (!fulfillment) {
                disabled = true;
                disabledInfo = "noFulfillment";
              }

              if (emptyProductField) {
                disabled = true;
                disabledInfo = "emptyProductField";
              }
            }
            if (
              id == STATUS_APPROVED &&
              state.order.order.approve_with_payment_link === true &&
              state.order.order.approve_with_payment_link_btn_label &&
              state.order.order.approve_with_payment_link_btn_label.length
            ) {
              status[id] =
                state.order.order.approve_with_payment_link_btn_label;
            }

            return {
              id: +id,
              text: status[id],
              disabled,
              disabledInfo,
            };
          }
        })
        .filter((item) => typeof item !== "undefined");
    },
    getInitStatus(state, getters) {
      if (!state.order || !state.statusList) return null;
      const id = state.order.order.status;
      const { getFilteredStatusList } = getters;
      const { status } = state.statusList;

      const filteredById = getFilteredStatusList.filter(
        (item) => item.id == id
      );

      if (!filteredById.length) return null;
      return {
        id,
        text: status[id],
      };
    },
    getShippings(state) {
      if (!state.order || !state.order.shippings) return [];
      const { shippings } = state.order.shippings;

      let result = Object.keys(shippings).map((k) => {
        return {
          id: k,
          text: shippings[k],
        };
      });

      result = [
        {
          id: 0,
          text: "",
        },
        ...result,
      ];

      return result;
    },
    showShippings(state) {
      return state.order && state.order.form.show_shipping;
    },
    getFilteredSubStatusById: (state) => (id) => {
      if (!state.order || !state.statusList || !state.statusList.substatus)
        return [];

      const { substatus } = state.statusList;
      const currentSubStatus = substatus[id];

      if (typeof currentSubStatus === "undefined") return [];

      return Object.entries(currentSubStatus).map(([id, value]) => {
        return {
          id,
          text: value,
        };
      });
    },
    getOrderCountries(state) {
      if (!state.order || !state.order.countries) return [];

      const { countries } = state.order;

      return Object.entries(countries).map(([value, text]) => {
        return {
          text,
          value: +value,
        };
      });
    },
    getOrderScript(state) {
      if (!state.order || !state.order.script) return;

      const script_first_step = state.order.order.script_first_step;
      const script = state.order.script;

      return {
        script,
        script_first_step,
      };
    },
    getRecallLang(state) {
      if (!state.order) return [];

      const { recall_lang_substatus } = state.order.order;

      if (!recall_lang_substatus) return [];

      return Object.entries(recall_lang_substatus).map(([id, value]) => {
        return {
          id,
          text: value,
        };
      });
    },
    getShippingsList(state) {
      const { shipping_list } = state.order.order;
      if (!shipping_list) {
        return [];
      }

      return Object.entries(shipping_list).map(([key, value]) => {
        return {
          key,
          text: value,
        };
      });
    },
    getDeliveryTypes(state) {
      if (!state.order) return [];
      const { delivery_type_list } = state.order;

      return Object.entries(delivery_type_list).map(([key, value]) => {
        return {
          key,
          text: value,
        };
      });
    },
    getIsIncomingOrder(state) {
      if (!state.order) return false;
      return state.order.order && state.order.order.is_incoming;
    },
    getIsCreatedOrder(state) {
      if (!state.order) return false;
      return (
        state.order.order && state.order.order.type_id === ORDER_TYPE_CREATED
      );
    },
    getIsDeliveryLogisticOrder(state) {
      if (!state.order) return false;
      return (
          state.order.order && state.order.order.type_id === ORDER_TYPE_DELIVERY_LOGISTIC
      );
    },
    getRequestFormType(state) {
      return state.requestFormType; //state.order.order.request_type;
    },
    openedFromPanel(state) {
      return state.requestFormType === FORM_REQUEST_TYPE_MANUAL || state.requestFormType === FORM_REQUEST_TYPE_PANEL;
    },
    getIsEditable(state) {
      if (!state.order) return;
      return (
        state.order.form &&
        (state.order.form.is_editable ||
          state.order.form.type == DISABLED_ORDER_TYPE) &&
        state.order.order.isEditable
      );
    },
    getIsEditableProduct(state) {
      if (!state.order) return;
      return (
        state.order.form &&
        (state.order.form.is_editable_product ||
          state.order.form.type == DISABLED_ORDER_TYPE)
      );
    },
    getAllowGifts(state) {
      if (!state.order) return;
      if(state.forms.productsAndSets.costs.includes(129000) && state.order.order.country_id === 30) {
          return true;
      }
      if(state.forms.productsAndSets.costs.includes(590) && state.order.order.country_id === 3) {
          return true;
      }
      if(state.forms.productsAndSets.costs.includes(690) && state.order.order.country_id === 3) {
          return true;
      }
      return state.order.form && state.order.form.allow_gifts;
    },
    getSimilarOrdersCount(state) {
      if (!state.order) return;
      return state.order.similar_orders
        ? state.order.similar_orders.length
        : null;
    },
    getOrderType(state) {
      if (!state.order || !state.orderTypes) return;
      const { type } = state.order.form;

      return state.orderTypes[type];
    },
    showGoogleAutocomplete(state) {
      const { order } = state;

      if (!order) false;

      const gmapAddressComponents = Object.values(order.order_address).map(
        (item) => item.gmap_address_component
      );

      const logResult = gmapAddressComponents.some((item) => item !== "");

      return gmapAddressComponents.some((item) => item !== "");
    },
    getOperatorsList(state) {
      if (!state.order) return [];
      const { operators } = state.order;
      if (operators) {
        return Object.entries(operators).map(([key, value]) => {
          return {
            key,
            text: value,
          };
        });
      }
    },
    hasEmptyProductField: (state) => {
      return state.forms.productsAndSets.products.some((product) => !product || !product.id);
    },
  },
  mutations: {
    SET_ORDER_INCOMING_CALL(state, payload) {
      if (!state.order || Number(state.order.order.id) !== Number(payload.order_id)) return;
      // Keep the operator's unsaved form while attaching a call to the open card.
      state.order = { ...state.order, order: { ...state.order.order, incoming_call: payload.incoming_call } };
    },
    SET_ORDER_DATA(state, payload) {
      googleAutocompleteAudit.start(payload && payload.order, googleAuditContour());
      state.allowReFetchOrder = false;
      state.order = payload;
      const storedDuration = readStoredOrderConversationDuration();
      const orderId = payload && payload.order ? Number(payload.order.id) : null;

      if (
        storedDuration &&
        orderId &&
        Number(storedDuration.orderId) === orderId
      ) {
        state.orderConversationDurationSeconds = Math.max(
          0,
          Number(storedDuration.durationSeconds) || 0
        );
      } else {
        state.orderConversationDurationSeconds = 0;
        clearStoredOrderConversationDuration();
      }
    },
    SET_SIMILAR_ORDERS_DATA(state, payload) {
      const currentOrderId = state.order && state.order.order
        ? Number(state.order.order.id)
        : null;

      if (currentOrderId !== Number(payload.orderId)) {
        return;
      }

      state.order.similar_orders = Array.isArray(payload.similarOrders)
        ? payload.similarOrders
        : [];
    },
    SET_ORDER_CONVERSATION_DURATION_DATA(state, payload) {
      state.orderConversationDurationSeconds = Math.max(0, Number(payload) || 0);
      const orderId = state.order && state.order.order ? state.order.order.id : null;
      writeStoredOrderConversationDuration(orderId, state.orderConversationDurationSeconds);
    },
    RESET_ORDER_CONVERSATION_DURATION_DATA(state) {
      state.orderConversationDurationSeconds = 0;
      clearStoredOrderConversationDuration();
    },
    SET_CUSTOM_DISCOUNT_DATA(state, payload) {
      state.customDiscount = payload;
    },
    SET_ORDER_STATUS_LIST_DATA(state, payload) {
      state.statusList = payload;
    },
    RESET_PRODUCTS_AND_SETS_FORM(state) {
      state.forms = {
        ...state.forms,
        productsAndSets: {
          count: 0,
          products: [
            {
              value: null,
              id: null,
              type: "product",
              disabled: false,
            },
          ],
          quantity: [1],
          costs: [0],
          free: [false],
          sumCosts: [0],
          gifts: [],
          originIds: [],
          prices: [],
          fulfillment: null,
          status: null,
          // isPaymentLink: false,
          discountedCosts: [],
          newSumCosts: [0],
          updatedCostForSetProduct: {},
        },
      };
      state.newSumCosts = [0];
      state.roundCorrectionKoef = 1;
      state.roundShippingCorrectionKoef = 1;
    },
    RESET_REQUEST_FORM(state) {
      state.forms = {
        ...state.forms,
        requestForm: {
          ...initData.requestForm,
        },
        transformOrderData: {},
      };
    },
    LEFT_SETS_ONLY(state) {
      const productsAndSetsCopy = state.forms.productsAndSets;
      const sets = productsAndSetsCopy.products
        .map((product) => {
          if (product.type === ORDER_PRODUCT_TYPE_SET) return product;
        })
        .filter((product) => product !== undefined);

      productsAndSetsCopy.count = 1;
      productsAndSetsCopy.products = sets;
      productsAndSetsCopy.quantity = productsAndSetsCopy.quantity.slice(0, 1);
      productsAndSetsCopy.costs = productsAndSetsCopy.costs.slice(0, 1);
      productsAndSetsCopy.free = productsAndSetsCopy.free.slice(0, 1);
      productsAndSetsCopy.prices = productsAndSetsCopy.prices.slice(0, 1);
      productsAndSetsCopy.sumCosts = productsAndSetsCopy.sumCosts.slice(0, 1);
      productsAndSetsCopy.originIds = productsAndSetsCopy.originIds.slice(0, 1);
      productsAndSetsCopy.gifts = productsAndSetsCopy.gifts.slice(0, 1);

      state.forms = {
        ...state.forms,
        productsAndSets: {
          ...productsAndSetsCopy,
          products: sets,
        },
      };
    },
    SET_SHOW_ORDER_FORM_DATA(state, payload) {
      state.showOrderForm = payload;
    },
    SET_IS_LOADING_ORDER_DATA(state, payload) {
      state.isLoadingOrder = payload;
    },
    SET_CURRENT_FULFILLMENT_DATA(state, payload) {
      state.forms = {
        ...state.forms,
        productsAndSets: {
          ...state.forms.productsAndSets,
          fulfillment: payload,
        },
      };
    },
    SET_CURRENT_STATUS_DATA(state, payload) {
      state.forms = {
        ...state.forms,
        productsAndSets: {
          ...state.forms.productsAndSets,
          status: payload,
        },
      };
    },
    SET_REQUEST_FORM_DATA(state, payload) {
      state.forms = {
        ...state.forms,
        requestForm: {
          ...state.forms.requestForm,
          ...payload,
        },
      };
    },
    SET_PRODUCTS_AND_SETS_DATA(state, payload) {
      state.forms = {
        ...state.forms,
        productsAndSets: payload,
      };
    },
    SET_TRANSFORMED_REQUEST_FORM_DATA(state, payload) {
      state.forms = {
        ...state.forms,
        transformOrderData: payload,
      };
    },
    SET_SHIPPING_DATA(state, payload) {
      state.forms = {
        ...state.forms,
        requestForm: {
          ...state.forms.requestForm,
          shipping_price: payload["data-price"],
        },
      };
    },
    SET_CUSTOM_SHIPPING_DATA(state, payload) {
      state.forms = {
        ...state.forms,
        requestForm: {
          ...state.forms.requestForm,
          shipping_price: payload.shipping,
          shipping_vat: payload.shippingVat,
        },
      };
    },
    RESET_SHIPPING_DATA(state) {
      state.forms = {
        ...state.forms,
        requestForm: {
          ...state.forms.requestForm,
          shipping_price: 0,
        },
      };
    },
    // SET_IS_PAYMENT_LINK_DATA(state, payload) {
    //   state.forms.productsAndSets.isPaymentLink = payload;
    // },
    SET_ORDER_OPERATOR(state, payload) {
      state.forms.requestForm.operator = payload.text;
      state.forms.requestForm.operator_id = payload.key;
    },
    SET_CUSTOM_PRODUCTS_SUMM_COSTS(state, payload) {
      state.forms.productsAndSets.sumCosts = payload;
      state.forms.productsAndSets.newSumCosts = payload;
    },
    SET_CURRENT_SUB_STATUS_DATA(state, payload) {
      state.forms.requestForm.sub_status = payload;
    },
    SET_RECALL_DATE_DATA(state, payload) {
      state.forms.requestForm = {
        ...state.forms.requestForm,
        recall_date: payload,
      };
    },
    SET_START_TIMESTAMP_DATA(state, payload) {
      state.forms.requestForm.start_timestamp = payload;
    },
    SET_FINAL_TIMESTAMP_DATA(state, payload) {
      state.forms.requestForm.final_timestamp = payload;
    },
    SET_REFETCH_ORDER_DATA(state, payload) {
      state.refetchOrder = payload;
    },
    SET_ORDER_ERRORS_DATA(state, payload) {
      state.errors = payload;
    },
    CLEAR_ORDER_FIELD_ERRORS(state, name) {
      const alias = { customer_mobile: "mobile_disp", customer_phone: "phone_disp" }[name];
      ["errors", "serverErrors"].forEach((source) => {
        if (!state[source]) return;
        const remaining = { ...state[source] };
        delete remaining[name];
        if (alias) delete remaining[alias];
        state[source] = remaining;
      });
    },
    SET_ORDER_ERRORS_RULES_DATA(state, payload) {
      state.errorsRules = payload;
    },
    RESET_ORDER_ERRORS_RULES_DATA(state) {
      state.errorsRules = null;
    },
    RESET_ORDER_ERRORS_DATA(state) {
      state.errors = null;
    },
    SET_ORDER_ADDRESS_DATA(state, payload) {
      state.forms.requestForm.address = {
        ...state.forms.requestForm.address,
        [payload.name]: payload.value,
      };
    },
    SET_ORDER_GENERAL_DATA(state, payload) {
      state.forms.requestForm.general = {
        ...state.forms.requestForm.general,
        [payload.name]: payload.value,
      };
    },
    RESET_ORDER_DATA(state) {
      googleAutocompleteAudit.stop();
      state.order = null;
      state.orderConversationDurationSeconds = 0;
    },
    SET_ORDER_PAGE_DATA(state, payload) {
      state.orderPage = payload;
    },
    SET_SCRIPTS_LOG_DATA(state, payload) {
      state.script.logs = payload;
    },
    RESET_SCRIPTS_DATA(state) {
      state.script = {
        finished: false,
        logs: [],
      };
    },
    SET_FINISHED_SCRIPT_DATA(state, payload) {
      state.script.finished = payload;
    },
    SET_ORDER_PHONES_DATA(state, payload) {
      const { key, value } = payload;

      const phones = state.forms.requestForm.phones;
      phones[key] = value;

      state.forms.requestForm.phones = phones;
    },
    SET_SERVER_ERRORS_DATA(state, payload) {
      state.serverErrors = payload;
    },
    RESET_SERVER_ERRORS_DATA(state) {
      state.serverErrors = null;
    },
    RESET_CALL_LOGS_DATA(state) {
      state.callLogId = null;
      state.callLogData = null;
    },
    SET_NO_VAT_CHECKBOX_DATA(state, payload) {
      state.noVATCheckbox = payload;
    },
    SET_VAT_PRODUCTS(state, payload) {
      state.vatProducts = payload;
    },
    RESET_DISCOUNTED_COSTS(state) {
      state.forms.productsAndSets = {
        ...state.forms.productsAndSets,
        discountedCosts: [],
      };
    },
    SET_IS_IFRAME(state, payload) {
      state.isIFrame = payload;
    },
    SET_REQUEST_FORM_TYPE(state, payload) {
      state.requestFormType = payload;
    },
    SET_IS_CREATED_ORDER(state, payload) {
      state.isCreated = payload;
    },
    SET_NOT_READY(state, payload) {
      state.notReadyCheckbox = payload;
    },
    SET_ALLOW_NO_VAT(state, payload) {
      state.isAllowNoVat = payload;
    },
    SET_CALL_LOG_ID_DATA(state, payload) {
      state.callLogId = payload;
    },
    SET_ORDER_TYPES(state, payload) {
      state.orderTypes = payload;
    },
    SET_ORDER_LOADING_MESSAGE(state, payload) {
      state.orderLoadingMessage = payload;
    },
    SET_IFRAME_ORDER_SAVED(state, payload) {
      state.isIframeOrderSaved = payload;
    },
    SET_AUTO_APPROVED_LINK(state, payload) {
      state.autoApproveLink = payload;
    },
    RESET_AUTO_APPROVED_LINK(state) {
      state.autoApproveLink = null;
    },
    SET_IS_ORDER_OPENED(state, payload) {
      state.isOrderOpened = payload;
    },
    REMOVE_CORRECTIONS_DATA(state, vm) {
      vm.$delete(state.forms.requestForm, "corrections");
      vm.$delete(state.forms.requestForm, "additionalCommentText");
    },
    SET_TRAINING_MODE_ON(state, payload) {
      state.switchToTrainingCheckbox = payload;
    },
    SET_CALL_LOG_DATA(state, payload) {
      state.callLogData = [];
    },
    SET_ORDER_LAST_ATTEMPTS_DATA_BY_OPERATOR(state, payload) {
      state.attemptsByCurrentOperator = payload;
    },
    CLEAR_ORDER_LAST_ATTEMPTS_DATA_BY_OPERATOR(state) {
      state.attemptsByCurrentOperator = [];
    },
    SET_IS_LOGISTIC_CALL(state, payload) {
      console.log('SET_IS_LOGISTIC_CALL', payload);
      state.isLogisticCall = payload;
    }
  },
  actions: {
    async ackOrderOpen({ state }, { order_id, attempt_token }) {
      if (!attempt_token || Number(state.order?.order?.id) !== Number(order_id)
        || state.order?.attempt_token !== attempt_token) return false;
      try {
        await api.ackOpen({ order_id, attempt_token });
      } catch (error) {
        if (error.response?.status === 409) {
          apiSocketService.handleCloseOrderCommand({ orderId: order_id, attempt_token, reason: 'ack_rejected' });
          return false;
        }
        throw error;
      }
      return Number(state.order?.order?.id) === Number(order_id)
        && state.order?.attempt_token === attempt_token;
    },
    clearGetOrderInterval() {
      clearInterval(refetchInterval);
      clearFetchOrderRetry();
    },
    resolveIncomingCall({ state, commit, dispatch }, payload) {
      if (activeIncomingCallPromise) {
        // A cancelled session's HTTP request may still be settling when the next SIP call arrives.
        return activeIncomingCallPromise.catch(() => null).then(() => dispatch('resolveIncomingCall', payload));
      }
      const { uniqueid, source_order_id, isCurrent, onReady } = payload;
      const request = Promise.resolve().then(async () => {
        // A status save already in flight owns the old card. Finish its cleanup first.
        if (activeSaveOrderPromise) await activeSaveOrderPromise;
        if (activeFetchOrderPromise) {
          try { await activeFetchOrderPromise; } catch (_) { /* An empty queue response is expected. */ }
        }
        if (isCurrent && !isCurrent()) return null;
        const { data: { data: context } } = await api.resolveIncomingCall({ uniqueid, source_order_id });
        if (isCurrent && !isCurrent()) return null;
        if (Number(state.order?.order?.id) !== Number(context.order_id)) {
          await dispatch('fetchOrder', context.order_id);
        }
        if (isCurrent && !isCurrent()) return null;
        if (Number(state.order?.order?.id) !== Number(context.order_id)) {
          throw new Error('Incoming call card could not be loaded');
        }
        commit('SET_ORDER_INCOMING_CALL', context);
        // Answer before releasing a status save that was clicked during this resolution.
        if (onReady) await onReady(context);
        return context;
      });
      activeIncomingCallPromise = request.finally(() => { activeIncomingCallPromise = null; });
      return activeIncomingCallPromise;
    },
    async fetchPriorityOrder({ dispatch, state, rootState, rootGetters }) {
      const previousRequest = activeFetchOrderPromise;
      if (previousRequest) {
        try {
          await previousRequest;
        } catch (error) {
          // The priority wakeup arrived after this request had already checked its queues.
        }
      }
      if (state.order || rootState.common.silentOperatorWarning || rootGetters.getPhoneHasActiveCall
        || String(window.sessionStorage.getItem("state")) !== "1") {
        return;
      }
      return dispatch("fetchOrder");
    },
    fetchOrder({ commit, dispatch, state, rootState }, order_id) {
      if (state.isIFrame) return;
      if (rootState.common.silentOperatorWarning) {
        commit("SET_IS_LOADING_ORDER_DATA", false);
        return Promise.resolve(false);
      }

      const normalizedOrderId = order_id || null;
      if (activeFetchOrderPromise) {
        if (activeFetchOrderId === normalizedOrderId || normalizedOrderId === null) {
          return activeFetchOrderPromise;
        }
      }

      commit("SET_SHOW_ORDER_FORM_DATA", true);
      commit("SET_IS_LOADING_ORDER_DATA", true);

      activeFetchOrderId = normalizedOrderId;
      activeFetchOrderPromise = api
        .get(order_id)
        .then(
          ({
            data: {
              data: { order },
            },
            status,
          }) => {
            if (status === 200) {
              if (rootState.common.silentOperatorWarning) {
                commit("SET_IS_LOADING_ORDER_DATA", false);
                return;
              }
              clearInterval(refetchInterval);
              clearFetchOrderRetry();

              // commit("RESET_ADDRES_CHECKING_STATE");
              const { is_vat_rounding } = order.form;

              if (is_vat_rounding) {
                tax.is_vat_rounding = is_vat_rounding;
              }

              const statusList = Object.assign({}, order.statuses_list);
              statusList.status = order.buttons;

              window.sessionStorage.removeItem(MAIN_PRODUCT_KEY);
              window.sessionStorage.removeItem(OPEN_AT_ORDER);
              window.sessionStorage.removeItem(STORAGE_ORDER_FORM);
              window.sessionStorage.removeItem(STORAGE_ORDER_SCRIPS);

              commit("SET_ORDER_DATA", order);
              commit("SET_IS_LOADING_ORDER_DATA", false);
              commit("SET_ORDER_LOADING_MESSAGE", "");
              commit("RESET_SNACKBAR_DATA");
              commit("SET_ORDER_STATUS_LIST_DATA", statusList);
              dispatch("fetchSimilarOrders", order.order.id);
              if (!order.attempt_token) EventBus.$emit("opened-order");
            }
          }
        )
        .catch((error) => {
          const scheduleRetryWithMessage = (message) => {
            commit("SET_ORDER_LOADING_MESSAGE", message);
            commit("SET_IS_LOADING_ORDER_DATA", true);
            commit("SET_SNACKBAR_DATA", {
              type: "error",
              text: message,
              duration: 0,
            });
            scheduleFetchOrderRetry(dispatch, order_id);
          };

          const response = error && error.response ? error.response : null;
          if (!response) {
            const networkErrorMessage = FETCH_ORDER_RETRY_MESSAGE;
            scheduleRetryWithMessage(networkErrorMessage);
            return Promise.reject(networkErrorMessage);
          }

          const status = response.status;
          const messages = response?.data?.data?.messages || [];

          if (status === 400) {
            clearFetchOrderRetry();
            commit("RESET_SNACKBAR_DATA");
            const { mode_auto } = rootState.employee.employee.userAttributes;

            let isLoading = true;
            if (mode_auto) {
              isLoading = false;

              EventBus.$emit(
                "set-customer-phone-number",
                MODE_AUTO_PHONE_NUMBER
              );
            }

            commit("SET_IS_LOADING_ORDER_DATA", isLoading);
            commit("SET_ORDER_LOADING_MESSAGE", messages[0]);
            EventBus.$emit("order-unavailable");
            //eslint-disable-next-line
            console.log("GET ORDER ERROR");

            return Promise.reject(messages[0]);
          }

          const fallbackMessage = FETCH_ORDER_RETRY_MESSAGE;
          scheduleRetryWithMessage(fallbackMessage);
          return Promise.reject(fallbackMessage);
        })
        .finally(() => {
          activeFetchOrderPromise = null;
          activeFetchOrderId = null;
        });

      return activeFetchOrderPromise;
    },
    transformOrderData({ commit, state, getters }, addData = {}) {
      var {
        products,
        quantity,
        sumCosts,
        newSumCosts,
        free,
        originIds,
        prices,
        status,
        fulfillment,
        gifts,
        discountedCosts,
        shipping_price
      } = state.forms.productsAndSets;

      const {
        country_id,
        init_price,
        set_id,
        mobile_part,
        phone_part,
        company_id,
        source_id,
        country_vat,
      } = state.order.order;

      const { notify_mobile, type } = state.order.form;

      const { logs } = state.script;

      let orderProduct = {};

      var newK = 0;
      products.forEach((product, k) => {
        let result = {};
        const resultKey = originIds[k];

        if (product.type === ORDER_PRODUCT_TYPE_PRODUCT) {
          let costs =
            typeof discountedCosts[k] !== "undefined"
              ? (newSumCosts[k] - discountedCosts[k]) * state.roundCorrectionKoef
              : newSumCosts[k] * state.roundCorrectionKoef;

          costs = window.currency(costs, {precision: 4}).value;

          result[resultKey || newK] = {
            id: originIds[k],
            product_id: +product.id,
            quantity: +quantity[k],
            gift: +free[k],
            price: free[k] ? 0 : +prices[k],
            cost: free[k] ? 0 : costs,
          };
        } else {
          const { sets } = state.order;
          const currentSet = Object.values(sets).filter(
            (set) => set.id == product.id
          )[0];

          if (typeof currentSet !== "undefined") {
            let updatedCostForSetProduct = {};
            if (state.forms.productsAndSets.updatedSetProducts) {
              state.forms.productsAndSets.updatedSetProducts.forEach((el) => {
                updatedCostForSetProduct[el.keyNumber] = el.cost;
              });
            }

            const {products} = currentSet;
            const MODIFIED_PRODUCTS = Object.entries(products).map((i) => {
                return {
                  keyNumber: i[0],
                  ...i[1],
                };
              });

            MODIFIED_PRODUCTS.map((product) => {
              let costs = +updatedCostForSetProduct[product.keyNumber]
                ? +updatedCostForSetProduct[product.keyNumber] * state.roundCorrectionKoef
                : 0;

              costs = window.currency(costs, { precision: 4 }).value;

              result[resultKey || newK] = {
                id: typeof originIds[k] !== "undefined" ? originIds[k] : null,
                product_id: +product.id,
                quantity: +product.quantity,
                cost: costs ? costs : +product.price,
                price: +product.price,
                gift: +product.price ? 0 : 1,
              };

              newK++;
            });
          }
        }

        if (!resultKey) newK++;

        gifts.forEach((gift) => {
          if (!gift) return;
          result[newK] = {
            id: null,
            product_id: +gift.add_product,
            quantity: +gift.add_product_quantity,
            cost: 0,
            price: 0,
            gift: 1,
          };
        });

        orderProduct = {
          ...orderProduct,
          ...result,
        };
      });

      const {
        customer_mobile,
        customer_phone,
      } = state.forms.requestForm.general;

      const mobile_disp = state.forms.requestForm.general.customer_mobile;
      const phone_disp = state.forms.requestForm.general.customer_phone;

      const requestForm = {
        ...state.forms.requestForm,
        general: {
          ...state.forms.requestForm.general,
          customer_mobile: getParsedNewPhone(customer_mobile, mobile_part),
          customer_phone: getParsedNewPhone(customer_phone, phone_part),
          // customer_phone: state.forms.requestForm.customer_phone_original,
          // customer_mobile: state.forms.requestForm.customer_mobile_original,
        },
      };

      delete requestForm.customer_phone_original;
      delete requestForm.customer_mobile_original;
      delete requestForm.isAllowNoVat;

      if (requestForm.additionalCommentText) {
        requestForm.corrections.comment = `${requestForm.additionalCommentText} ${requestForm.corrections.comment}`;
        delete requestForm.additionalCommentText;
      }

      let shippingPrice = window.currency(getters.getShippingPrice * state.roundShippingCorrectionKoef, {precision: 4}).value;
      if (status.id === STATUS_APPROVED_PARTIAL_PAYMENT_LINK) {
        status.id = STATUS_APPROVED;
        this.partial_payment_link = true
      } else {
        this.partial_payment_link = false;
      }

      const order = {
        ...requestForm,
        discount: requestForm.discount ? +requestForm.discount : null,
        OrderProduct: type !== ORDER_TYPE_INCOME ? orderProduct : [],
        status: status.id,
        country_id,
        init_price,
        final_price: +getters.getTotalSum,
        fulfillment_id: fulfillment ? fulfillment.id : null,
        set_id,
        mobile_part,
        mobile_disp,
        phone_part,
        phone_disp,
        no_vat: +state.noVATCheckbox,
        is_notify_mobile: +notify_mobile,
        payment_link_attr: null,
        comment_author: null,
        step_log: JSON.stringify(logs),
        shipping_price: shippingPrice,
        total_timestamp: Math.round(+new Date()),
        order_call_log: state.callLogId,
        opened_at: requestForm.opened_at,
        company: company_id,
        source_id: source_id,
        partial_payment_link: this.partial_payment_link,
        ...addData,
      };

      commit("SET_TRANSFORMED_REQUEST_FORM_DATA", order);
    },
    async saveOrder({ state, commit, dispatch, getters, rootState }, { vm, approveLink }) {
      if (activeSaveOrderPromise) return activeSaveOrderPromise;
      const originalOrderId = state.order?.order?.id;
      const originalAttemptToken = state.order?.attempt_token;
      const isCurrentAttempt = () => originalOrderId === state.order?.order?.id
        && originalAttemptToken === state.order?.attempt_token;
      if (activeIncomingCallPromise) {
        let attached = false;
        try { attached = Boolean(await activeIncomingCallPromise); } catch (_) { /* Failed resolution leaves the old card. */ }
        if (attached || originalOrderId !== state.order?.order?.id || originalAttemptToken !== state.order?.attempt_token) {
          EventBus.$emit('order-procceing', false);
          commit('SET_SNACKBAR_DATA', { type: 'error', text: vm.$t(window.Vocabulary.cantSaveStatusDuringCall) });
          return false; // Never save an old form over the incoming card or hang up its new call.
        }
      }
      const { transformOrderData } = state.forms;

      if (getters.checkIsSetInForm) {
        const SET_ID = getters.getSelectedSetInForm[0].id;
        transformOrderData.set_id = SET_ID;
      } else {
        transformOrderData.set_id = null;
      }

      const data = {
        Order: {
          ...transformOrderData,
        },
        OrderProduct: {
          ...transformOrderData.OrderProduct,
        }
      };
      const stopAfterSave = Boolean(state.notReadyCheckbox || state.switchToTrainingCheckbox);
      const switchToTraining = Boolean(state.switchToTrainingCheckbox);
      if (originalAttemptToken) {
        data.attempt_token = originalAttemptToken;
        data.stop_after_save = stopAfterSave;
      }

      if (typeof approveLink !== "undefined") {
        data["approve-link"] = approveLink;
      }
      const orderId = state.order.order.id;

      const googleAuditReport = googleAutocompleteAudit.snapshot(state.order.order, googleAuditContour());
      if (googleAuditReport) data.google_autocomplete_audit = googleAuditReport;

      delete data.Order.OrderProduct;

      let action;
      if (state.order.order.is_created) {
        action = api.create(data);
      } else {
        action = api.save(data, orderId);
      }

      const savePromise = action
        .then(async ({ status, data: responseData }) => {
          if (status == 200) {
            if (!isCurrentAttempt()) {
              return true;
            }
            if (responseData && responseData.status === "success" && responseData.data
              && responseData.data.retry_call !== true) {
              googleAutocompleteAudit.complete(googleAuditReport);
            }
            if (typeof vm.handleDoubleFirstRetryResponse === "function") {
              const retryCallRequested = await vm.handleDoubleFirstRetryResponse(
                responseData
              );
              if (!isCurrentAttempt()) return true;
              if (retryCallRequested) {
                return true;
              }
            }

            vm.afterSave();
            commit("RESET_AUTO_APPROVED_LINK");

            if (state.isIFrame) {
              commit("SET_IFRAME_ORDER_SAVED", true);
              window.localStorage.removeItem("locale");
            }

            commit("SET_SNACKBAR_DATA", {
              type: "success",
              text: vm.$t(window.Vocabulary.orderSaveSuccess),
            });

            commit("RESET_ORDER_CONVERSATION_DURATION_DATA");
            if (!activeIncomingCallPromise) EventBus.$emit("clear-phone-data", true);
            if (!stopAfterSave) {
              const hasPendingSilentOperatorWarning = Boolean(
                rootState.common.silentOperatorWarning
              );
              commit("RESET_PRODUCTS_AND_SETS_FORM");
              commit("RESET_ORDER_ERRORS_RULES_DATA");
              commit("RESET_ORDER_ERRORS_DATA");
              commit("RESET_ORDER_DATA");
              commit("RESET_SCRIPTS_DATA");
              commit("RESET_SERVER_ERRORS_DATA");
              commit("SET_REFETCH_ORDER_DATA", !hasPendingSilentOperatorWarning);
              commit("SET_IS_LOADING_ORDER_DATA", !hasPendingSilentOperatorWarning);
              commit("RESET_CALL_LOGS_DATA");
              EventBus.$emit("reset-order-timer", true);
              if (!hasPendingSilentOperatorWarning && !activeIncomingCallPromise) {
                dispatch("fetchOrder");
              }
            } else {
              EventBus.$emit("reset-start-job", true);
              dispatch("changeReady", {
                state: EMPLOYEE_STATE_INACTIVE,
                target: "checkbox_finish_work",
              });
              window.sessionStorage.setItem("state", EMPLOYEE_STATE_INACTIVE);

              if (switchToTraining) {
                EventBus.$emit("show-training-modal", true);
              }
            }

            commit("SET_SERVER_ERRORS_DATA", {});
            commit("SET_ORDER_ERRORS_DATA", {});
            commit("SET_IS_ORDER_OPENED", false);
            commit("SET_NO_VAT_CHECKBOX_DATA", false);
            commit("SET_CUSTOM_DISCOUNT_DATA", {});

            setTimeout(() => {
              if (state.order && !isCurrentAttempt()) return;
              window.sessionStorage.removeItem(STORAGE_ORDER_FORM);
              window.sessionStorage.removeItem(STORAGE_ORDER_SCRIPS);
            }, 500);

            parent.postMessage({ event: "order-saved", data: responseData }, "*");
          }

          return false;
        })
        .then((retryCallRequested) => {
          if (!retryCallRequested) {
            EventBus.$emit("saved-order");
          }
        })
        .catch((error) => {
          if (!isCurrentAttempt()) return;
          const status = error.response?.status;
          const errors = error.response?.data?.data?.errors || {};
          const messages = error.response?.data?.data?.messages || [];

          if (!error.response) {
            commit('SET_SNACKBAR_DATA', { type: 'error', text: 'Не удалось сохранить заказ. Проверьте соединение и повторите попытку.' });
            return;
          }

          if (status === 400) {
            (messages || []).forEach((message) => {
              setTimeout(() => {
                if (!isCurrentAttempt()) return;
                commit("SET_SNACKBAR_DATA", {
                  type: "error",
                  text: message,
                });
              }, 200);
            });

            if (errors.auto_approve_link) {
              commit("SET_AUTO_APPROVED_LINK", errors.auto_approve_link);
              delete errors.auto_approve_link;
            }

            Object.values(errors).forEach((error) => {
              if (isArray(error)) {
                error.forEach((text) => {
                  setTimeout(() => {
                    if (!isCurrentAttempt()) return;
                    commit("SET_SNACKBAR_DATA", {
                      type: "error",
                      text: text,
                    });
                  }, 200);
                });
              }
            });

            const result = normalizeOrderErrors(errors, messages);
            commit("SET_SERVER_ERRORS_DATA", { ...errors });

            commit("SET_ORDER_ERRORS_DATA", result);
          }
        })
        .finally(() => {
          if (activeSaveOrderPromise === savePromise) activeSaveOrderPromise = null;
          EventBus.$emit("order-procceing", false);
        });
      activeSaveOrderPromise = savePromise;
      return savePromise;
    },
    setShippingPriceById({ commit, state }, payload) {
      const currentShipping = state.order.shippings.shipping_options[payload];

      if (currentShipping) {
        commit("SET_SHIPPING_DATA", currentShipping);
      } else {
        commit("RESET_SHIPPING_DATA");
      }
    },
    async changeOrderCountry({ commit }, payload) {
      const { id, data } = payload;

      const result = await api
        .changeOrderCountry(data, id)
        .then(
          ({
            status,
            data: {
              data: { data },
            },
          }) => {
            if (status == 200) {
              commit("SET_SNACKBAR_DATA", {
                type: "success",
                text: data.message,
              });
              commit("RESET_PRODUCTS_AND_SETS_FORM");
              commit("RESET_ORDER_ERRORS_RULES_DATA");
              commit("RESET_ORDER_ERRORS_DATA");
              commit("SET_REFETCH_ORDER_DATA", true);
              commit("RESET_ORDER_DATA");
              commit("RESET_SCRIPTS_DATA");
              commit("SET_IS_LOADING_ORDER_DATA", true);

              return true;
            }
          }
        )
        .catch((error) => {
          const {
            response: {
              data: {
                data: { messages },
              },
              status,
            },
          } = error;

          if (status === 400) {
            commit("SET_SNACKBAR_DATA", {
              type: "error",
              text: messages ? messages[0] : "Error",
            });
          }

          return false;
        });

      return result;
    },
    saveOrderCallLog({ commit }, payload) {
      const { await_ack, ...logPayload } = payload;
      let resolveAck;
      let ackTimer;
      const ackPromise = await_ack ? new Promise((resolve) => {
        resolveAck = resolve;
        ackTimer = setTimeout(() => resolve(false), 8000);
      }) : undefined;
      apiSocketService.enqueuePhoneCallLog(logPayload, {
        onRejected: () => { if (resolveAck) { clearTimeout(ackTimer); resolveAck(false); } },
        onAck: ({ call_log_id, log_data = {} }) => {
          const resolvedCallLogId = call_log_id || log_data.call_log_id;
          if (resolvedCallLogId) {
            commit("SET_CALL_LOG_ID_DATA", resolvedCallLogId);
          }
          if (resolveAck) { clearTimeout(ackTimer); resolveAck(Boolean(resolvedCallLogId)); }
        },
      });

      const { HANGUP } = LOG_TYPES;
      if (payload.type === HANGUP) {
        EventBus.$emit("enable-call-list-call-button");
      }
      return ackPromise;
    },
    async sendIncomeCallNumber(ctx, payload) {
      try {
        const result = await api.sendIncomeCallNumber(payload);
        const {
          data: {
            data: { id },
          },
        } = result;
        return Promise.resolve(id);
      } catch (e) {
        const {
          response: {
            data: {
              data: { messages },
            },
          },
        } = e;
        return Promise.reject(messages);
      }
    },
    async getDeliveryOrder(ctx, payload) {
      try {
        const result = await api.getDeliveryOrder(payload);
        const {
          data: {
            data: { order },
          },
        } = result;
        return Promise.resolve(order);
      } catch (e) {
        const {
          response: {
            data: {
              data: { message },
            },
          },
        } = e;
        return Promise.reject(message);
      }
    },
    completeOrderCall({ commit }, payload) {
      api.completeOrderCall(payload).then(({ status }) => {
        if (status === 200) {
          //eslint-disable-next-line
          console.log("COMPLETED");
          // EventBus.$emit("set-customer-phone-number", MODE_AUTO_PHONE_NUMBER);
        }
      });
    },
    makePhoneCall() {
      // console.log("makePhoneCall");
      EventBus.$emit("set-customer-phone-number", MODE_AUTO_PHONE_NUMBER);
    },
    async sendOrderInfo(ctx, payload) {
      try {
        const result = await api.sendOrderInfo(payload);
        const {
          data: {
            data: { messages },
          },
        } = result;
        return Promise.resolve(messages);
      } catch (e) {
        const {
          response: {
            data: {
              data: { messages },
            },
          },
        } = e;

        return Promise.reject(messages);
      }
    },
    async resendPaymentLink(ctx, payload) {
      try {
        const result = await api.resendPaymentLink(payload);
        const {
          data: {
            data: { messages },
          },
        } = result;
        return Promise.resolve(messages);
      } catch (e) {
        const {
          response: {
            data: {
              data: { messages },
            },
          },
        } = e;

        return Promise.reject(messages);
      }
    },
    refetchOrder({ dispatch, state }, vm) {
      // if (!state.isLoadingOrder) {
      //   dispatch('fetchOrder');
      // }

      window.sessionStorage.removeItem(STORAGE_ORDER_FORM);

      refetchInterval = setInterval(() => {
        if (!state.isLoadingOrder) {
          clearInterval(refetchInterval);
          vm.$router.push({
            name: "order.edit",
          });
          return;
        }

        dispatch("fetchOrder", vm);
      }, 20000);
    },
    getPaylinksLifetime({ commit }, payload) {
      api.getPaylinksLifetime(payload).then(
          ({
             status,
             data: {
               data: { result },
             },
           }) => {
            if (status === 200) {
              EventBus.$emit("refresh-paylinks-lifetime", result);
            }
          }
      );
    },
    fetchSimilarOrders({ commit }, orderId) {
      if (apiContour.getCurrentContour() !== API_CONTOUR_ORCHESTRATOR || !orderId) {
        return Promise.resolve();
      }

      return api.getSimilarOrders(orderId)
        .then(({ data, status }) => {
          if (status !== 200) {
            return;
          }

          commit("SET_SIMILAR_ORDERS_DATA", {
            orderId,
            similarOrders: data?.data?.similar_orders || [],
          });
        })
        .catch(() => null);
    },
    getAuditInfo({ commit }, payload) {
      api.getAuditInfo(payload).then(
        ({
          status,
          data: {
            data: { records, audit },
          },
        }) => {
          if (status === 200) {
            EventBus.$emit("show-audit-info-modal", { records, audit });
          }
        }
      );
    },
    getScriptsByCountry({ commit }, payload) {
      api.getScriptsByCountry(payload).then(({ data, status }) => {
        if (status === 200) {
          EventBus.$emit("get-scripts-by-country", data);
        }
      });
    },
    getScriptById({ commit }, payload) {
      api.getScript(payload).then(({ data, status }) => {
        if (status === 200) {
          EventBus.$emit("get-script-by-id", data);
        }
      });
    },
    getAttemptsData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.getOrderAttemptsDataByOperator(payload).then(({data, status}) => {
          if (status === 200) {
              const orderRecordsData = data.data.orderRecordsData;
              commit('CLEAR_ORDER_LAST_ATTEMPTS_DATA_BY_OPERATOR');
            if ((Array.isArray(orderRecordsData) && orderRecordsData.length > 0) ||
                (typeof orderRecordsData === 'object' && orderRecordsData !== null && !Array.isArray(orderRecordsData))) {
              commit('SET_ORDER_LAST_ATTEMPTS_DATA_BY_OPERATOR', orderRecordsData);
              resolve(true);
            } else {
              // Очистка данных, если массив пустой
              commit('CLEAR_ORDER_LAST_ATTEMPTS_DATA_BY_OPERATOR');
              resolve(false);
            }
          }
        });
      });
    },
  },
};

function getParsedNewPhone(value, part) {
  let result = value;
  if (!result || !result.includes("xxxxx")) return result;

  result = result.slice(0, -5);
  if (!part) return result;
  result += part;

  return result;
}
